import { Component, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { GmailGenerateOtpComponent } from '../../common/gmail-generate-otp/gmail-generate-otp.component';
import { MainChangeNumberComponent } from '../../common/main-change-number/main-change-number.component';
import { MainForgotPasswordComponent } from '../../common/main-forgot-password/main-forgot-password.component';
import { MainOtpVerificationComponent } from '../../common/main-otp-verification/main-otp-verification.component';
import { MainSignupComponent } from '../../common/main-signup/main-signup.component';
import { SigninComponent } from '../signin/signin.component';
import { MobileNumberComponent } from '../mobile-number/mobile-number.component';

@Component({
    selector: 'app-desktop-login-wrapper',
    templateUrl: './desktop-login-wrapper.component.html',
    styleUrls: ['./desktop-login-wrapper.component.scss'],
    standalone: true,
    imports: [MobileNumberComponent, SigninComponent, MainSignupComponent, MainOtpVerificationComponent, MainForgotPasswordComponent, MainChangeNumberComponent, GmailGenerateOtpComponent]
})
export class DesktopLoginWrapperComponent {
    step: string;

    constructor(
        private dialogRef: MatDialogRef<DesktopLoginWrapperComponent>,
        private authenticationService: AuthenticationService,
        private ngZone: NgZone
    ) {
        this.authenticationService.step.subscribe((data: string) => {
            this.step = data;
        });

        this.authenticationService.closeWrapperDialog.subscribe(data => {
            this.dialogRef.close(data);
        });
    }

    close(data: { authentication: boolean } = { authentication: false }) {
        this.ngZone.run(() => {
            this.dialogRef.close(data);
        });
    }
}
